// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switcher[data-v-2ab91774]{font-size:12px}.switcher[data-v-2ab91774],.switcher[data-v-2ab91774]:focus{border:none!important}", ""]);
// Exports
module.exports = exports;
